import { render, staticRenderFns } from "./emme.vue?vue&type=template&id=028f2fe8&scoped=true&"
import script from "./emme.vue?vue&type=script&lang=js&"
export * from "./emme.vue?vue&type=script&lang=js&"
import style0 from "./emme.vue?vue&type=style&index=0&id=028f2fe8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028f2fe8",
  null
  
)

export default component.exports